import SuperJSON from "superjson";
import Id from "../types/Id";

export default class FolderId extends Id<"folder"> {}

SuperJSON.registerClass(FolderId, { identifier: "FolderId" });
